import { render, staticRenderFns } from "./recommendShop.vue?vue&type=template&id=70d7dbdc&scoped=true"
import script from "./recommendShop.vue?vue&type=script&lang=js"
export * from "./recommendShop.vue?vue&type=script&lang=js"
import style0 from "./recommendShop.vue?vue&type=style&index=0&id=70d7dbdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d7dbdc",
  null
  
)

export default component.exports